import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-advocacia")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-advocacia"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-advocacia"]!.metaDescription,
    path: "/agente-ia-advocacia",
  }),
  component: () => <SegmentRoute slug="agente-ia-advocacia" />,
});
